// extracted by mini-css-extract-plugin
export default {"stickyToolbar":"Details_stickyToolbar__ErJW9","filterChip":"Details_filterChip__nJAon"};